/* CUSTOM - "Build Your Set" PDP module (Hyperfavor spec).
   Tier selector (1 / 2-mix / 4-mix) + slot picker + dynamic single CTA + free-ship bar.
   Pairs with the "Tiered bundle discount" function (2 covers -> 10%, 4 -> 20%). */
(function () {
  if (customElements.get('build-your-set')) return;

  const money = (cents) => '$' + (cents / 100).toFixed(2);

  class BuildYourSet extends HTMLElement {
    connectedCallback() {
      this.freeship = parseInt(this.dataset.freeship, 10) || 0;
      this.discountActive = this.dataset.discountActive === 'true';

      const cur = this.querySelector('[data-bys-current]');
      this.current = {
        variantId: cur.dataset.variantId,
        price: parseInt(cur.dataset.price, 10) || 0,
        title: cur.dataset.title,
        image: cur.dataset.image,
      };

      this.slotsEl = this.querySelector('[data-bys-slots]');
      this.shipFill = this.querySelector('[data-bys-ship-fill]');
      this.shipMsg = this.querySelector('[data-bys-ship-msg]');
      this.cta = this.querySelector('[data-bys-cta]');
      this.errorEl = this.querySelector('[data-bys-error]');
      this.picker = this.querySelector('[data-bys-picker]');
      this.picks = Array.from(this.querySelectorAll('[data-bys-pick]'));
      this.tierInputs = Array.from(this.querySelectorAll('[data-bys-tier]'));

      this.tier = parseInt(
        (this.tierInputs.find((i) => i.checked) || this.tierInputs[0]).value,
        10
      );
      this.chosen = []; // [{variantId, price, title, image}]
      this.pickerTarget = 0; // index into chosen[] being filled

      // Events
      this.tierInputs.forEach((i) =>
        i.addEventListener('change', () => { this.setTier(parseInt(i.value, 10)); this.toggleCTS(); })
      );
      this.cta.addEventListener('click', () => this.onCta());
      this.picks.forEach((p) =>
        p.addEventListener('click', () => this.onPick(p))
      );
      this.querySelectorAll('[data-bys-picker-close]').forEach((el) =>
        el.addEventListener('click', () => this.closePicker())
      );
      const viewAll = this.querySelector('[data-bys-viewall]');
      if (viewAll)
        viewAll.addEventListener('click', () => {
          this.querySelectorAll('.bys__pick--extra').forEach((el) =>
            el.classList.remove('bys__pick--extra')
          );
          viewAll.hidden = true;
        });

      this.render();
      this.toggleCTS();
    }

    toggleCTS() {
      const cts = document.querySelector('complete-the-set');
      if (cts) cts.hidden = this.tier !== 1;
    }

    mainVariantId() {
      const input = document.querySelector('.js-product-form [name="id"]');
      return input && input.value ? input.value : this.current.variantId;
    }

    covers() {
      return [{ ...this.current, variantId: this.mainVariantId() }, ...this.chosen];
    }

    setTier(tier) {
      this.tier = tier;
      // Trim extra chosen if the new tier needs fewer.
      this.chosen = this.chosen.slice(0, Math.max(0, tier - 1));
      this.render();
    }

    // ---- Slots ----
    render() {
      const need = this.tier - 1; // number of extra designs to pick
      const ordinals = ['2nd', '3rd', '4th'];
      let html = this.slotTile(this.current, { locked: true });
      for (let i = 0; i < need; i++) {
        const chosen = this.chosen[i];
        html += chosen
          ? this.slotTile(chosen, { index: i })
          : `<button type="button" class="bys__slot bys__slot--empty" data-slot="${i}">
               <span class="bys__slot-plus">+</span>
               <span class="bys__slot-label">Choose ${ordinals[i] || 'Next'} Design</span>
             </button>`;
      }
      this.slotsEl.innerHTML = html;
      this.slotsEl
        .querySelectorAll('[data-slot]')
        .forEach((el) =>
          el.addEventListener('click', () =>
            this.openPicker(parseInt(el.dataset.slot, 10))
          )
        );
      this.slotsEl
        .querySelectorAll('[data-change]')
        .forEach((el) =>
          el.addEventListener('click', () =>
            this.openPicker(parseInt(el.dataset.change, 10))
          )
        );
      this.updateSummary();
    }

    slotTile(item, opts) {
      const img = item.image
        ? `<img src="${item.image}" alt="" loading="lazy">`
        : '';
      const meta = opts.locked
        ? `<span class="bys__slot-tag">In your set</span>`
        : `<button type="button" class="bys__slot-change" data-change="${opts.index}">Change</button>`;
      return `<div class="bys__slot bys__slot--filled">
                <span class="bys__slot-thumb">${img}</span>
                <span class="bys__slot-info">
                  <span class="bys__slot-name">${item.title}</span>
                  ${meta}
                </span>
                <span class="bys__slot-price">${money(item.price)}</span>
              </div>`;
    }

    // ---- Picker ----
    openPicker(targetIndex) {
      this.pickerTarget = targetIndex;
      const taken = new Set(this.covers().map((c) => c.variantId));
      // The slot being replaced shouldn't disable its own current pick.
      const replacing = this.chosen[targetIndex];
      if (replacing) taken.delete(replacing.variantId);
      this.picks.forEach((p) => {
        const inSet = taken.has(p.dataset.variantId);
        p.classList.toggle('bys__pick--in-set', inSet);
        p.disabled = inSet;
      });
      this.picker.hidden = false;
      document.body.classList.add('bys-picker-open');
    }

    closePicker() {
      this.picker.hidden = true;
      document.body.classList.remove('bys-picker-open');
    }

    onPick(p) {
      if (p.disabled) return;
      const item = {
        variantId: p.dataset.variantId,
        price: parseInt(p.dataset.price, 10) || 0,
        title: p.dataset.title,
        image: p.dataset.image,
      };
      this.chosen[this.pickerTarget] = item;
      this.closePicker();
      this.render();
    }

    // ---- Summary: total, free-ship, CTA ----
    computeTotal() {
      const covers = this.covers();
      const subtotal = covers.reduce((s, c) => s + c.price, 0);
      let pct = 0;
      if (this.discountActive) {
        if (covers.length >= 4) pct = 20;
        else if (covers.length >= 2) pct = 10;
      }
      const discount = Math.round((subtotal * pct) / 100);
      return { subtotal, discount, total: subtotal - discount, pct, count: covers.length };
    }

    remainingToPick() {
      return this.tier - 1 - this.chosen.length;
    }

    updateSummary() {
      const { subtotal, discount, total } = this.computeTotal();
      const remaining = this.remainingToPick();

      // CTA label (spec 2.5)
      if (this.tier === 1) {
        this.cta.textContent = `Add to Bag — ${money(this.current.price)}`;
        this.ctaAction = 'add';
      } else if (remaining > 0) {
        const ord = this.chosen.length === 0 && this.tier === 2 ? 'Your 2nd Design' : `${remaining} More Design${remaining > 1 ? 's' : ''}`;
        this.cta.textContent = `Choose ${ord}`;
        this.ctaAction = 'pick';
      } else {
        this.cta.textContent = `Add Set to Cart — ${money(total)}`;
        this.ctaAction = 'add';
      }

      // Free-ship bar (uses total-so-far)
      if (this.freeship > 0) {
        const pctBar = Math.max(0, Math.min(100, (total / this.freeship) * 100));
        this.shipFill.style.width = pctBar + '%';
        const remain = this.freeship - total;
        this.shipMsg.textContent =
          remain > 0 ? `Add ${money(remain)} for free shipping` : 'Your order ships free';
        this.shipFill.classList.toggle('is-full', total >= this.freeship);
      }
    }

    setError(msg) {
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }

    onCta() {
      if (this.ctaAction === 'pick') {
        const next = this.chosen.length; // first empty slot
        this.openPicker(next);
        return;
      }
      this.addToCart();
    }

    async addToCart() {
      const items = this.covers().map((c) => ({ id: c.variantId, quantity: 1 }));
      this.setError('');
      this.cta.classList.add('is-loading');
      this.cta.setAttribute('aria-disabled', 'true');

      const sections = ['page-header', 'cart-drawer']
        .map((sel) => document.querySelector(sel))
        .filter(Boolean);
      const sectionIds = sections.map((el) => el.dataset.sectionId).filter(Boolean);

      try {
        const res = await fetch(
          (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          }
        );
        const data = await res.json();
        if (!res.ok)
          throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');

        if (data.sections) {
          sections.forEach((el) => {
            if (data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            }
          });
        }
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items } }));

        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(this.cta);
        else this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

        this.cta.classList.remove('is-loading');
        this.cta.classList.add('is-success');
        setTimeout(() => this.cta.classList.remove('is-success'), 2000);
      } catch (err) {
        this.cta.classList.remove('is-loading');
        this.setError(err.message || 'Could not add to cart. Please try again.');
      } finally {
        this.cta.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('build-your-set', BuildYourSet);
})();
